import { createContext, FunctionComponent, useState, useMemo } from 'react';
import { singleton } from '@animavirtuality/utils';

export type EffectContextValue = {
    pixelate: boolean; // begin mosaic animation. Go from normal -> pixelated -> normal
    setPixelate: (pixelate: boolean) => void;
    maxPixelGranularity: boolean; // immediately go to max pixelation granularity
    setMaxPixelGranularity: (maxPixelation: boolean) => void;
    easeInBloom: boolean;
    setEaseInBloom: (easeInBloom: boolean) => void;
};

export const EffectContext = singleton(() => createContext<EffectContextValue | null>(null));

export const EffectContextProvider: FunctionComponent = ({ children }) => {
    const [pixelate, setPixelate] = useState<boolean>(false);
    const [maxPixelGranularity, setMaxPixelGranularity] = useState<boolean>(false);
    const [easeInBloom, setEaseInBloom] = useState<boolean>(false);

    const value = useMemo(
        () => ({
            pixelate,
            setPixelate,
            maxPixelGranularity,
            setMaxPixelGranularity,
            easeInBloom,
            setEaseInBloom,
        }),
        [easeInBloom, maxPixelGranularity, pixelate]
    );

    const context = EffectContext();
    return <context.Provider value={value}>{children}</context.Provider>;
};
